import {guard} from '@acng/frontend-rubicon';
import {user} from '../../user/user.js';
import {PictureSet, fixPictureSetData} from '../model/picture-set.js';
import {deleteUnusedFields, fixPreviewImage} from '../../core/model/gallery.js';
import {forEach} from '@acng/frontend-bounty/std/array.js';
import {fixPictureData} from '../model/picture.js';
import {PICTURE_SET_DATA} from '../service/guard.js';
import {NotFoundWithBlocked} from 'acng/userPool/model/stock.js';
import {ERROR_RESPONSE_BODY} from 'acng/core/model/backend.js';

angular
  .module('picturePool')
  .factory('PictureSet', [
    'http',
    'HttpCache',
    function (http, HttpCache) {
      const cache = new HttpCache({
        prefix: '/api/picture/sets/',
        useCdn: true,
        fnError: (err, id) => {
          if (err.status == 404 || err.status == -1) {
            return http()
              .get('/api/picture/set/blocked/' + id, {dontIntercept: true})
              .catch((error) => {
                if (error.status == 404) {
                  ASSERT: guard(error.data, ERROR_RESPONSE_BODY);
                  throw new NotFoundWithBlocked(error.data.code);
                }

                throw error;
              });
          }
          throw err;
        },
        fnRequest: (id) => http(true).get(`/api/picture/set/${id}`, {dontIntercept: true}),
        fnResolve: (res) => {
          res.data.category_codes ??= [];
          deleteUnusedFields(res.data);
          fixPictureSetData(res.data);
          forEach(res.data.rawItems, (pictureData) => {
            pictureData.price = res.data.price;
            fixPictureData(pictureData);
          });
          ASSERT: guard(res.data, PICTURE_SET_DATA, 'picture set data');
          fixPreviewImage(res.data);
          return new PictureSet(res.data);
        },
      });
      const hideOldDate = new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString(); // 3 months

      PictureSet.doNotShow = [];

      PictureSet.isValidId = (id) => !isNaN((id = parseInt(id))) && id;

      PictureSet.get = function (id) {
        return cache.get(parseInt(id));
      };

      PictureSet.list = function (limit, offset, filter, type) {
        return http()
          .get('/api/picture/lists' + (type ? `/${type}` : ''), {
            params: {
              limit: limit,
              offset: offset,
              fsk: user.getListFsk(),
              filter: JSON.stringify(filter),
            },
            dontIntercept: true,
          })
          .then((res) => res.data);
      };

      return PictureSet;
    },
  ])

  .directive('onsdPictureSets', [
    'PimpMyRide',
    'PictureSet',
    (PimpMyRide, PictureSet) =>
      PimpMyRide(
        'PictureSets',
        ['nickname', 'search', 'categories', 'limit', 'type'],
        (v) => {
          return PictureSet.list(
            v[3],
            0,
            {
              nickname: v[0] || '',
              search: v[1] || '',
              categories: (v[2] || '').split(',').filter((v) => !!v),
            },
            v[4],
          ).then((res) => {
            PictureSet.doNotShow.forEach((id) => {
              let i = res.data.indexOf(id);
              if (i >= 0) {
                res.data.splice(i, 1);
              }
            });
            return res.data;
          });
        },
        (v) => v[3] > 0,
      ),
  ])

  .directive('onsdMorePictureSets', [
    'PimpMyRide',
    'PictureSet',
    (PimpMyRide, PictureSet) =>
      PimpMyRide(
        'MorePictureSets',
        ['setId', 'type', 'limit'],
        (v) => PictureSet.get(v[0]).then((set) => set.more(v[1], Math.max(0, parseInt(v[2])) || 5)),
        (v) => PictureSet.isValidId(v[0]) && /^(nickname|recommendation)$/.test(v[1]),
      ),
  ]);
